export default {
  offerText: {
    en: 'Get a free perfume with your next shipment',
  },
  offerProduct: {
    en: '<b class="brand">{brand}</b> - <span class="name">{name}</span>',
  },
  ribbonText: {
    en: 'Your gift',
  },
}
